import React from 'react';
import CountryFlag from './CountryFlag';
import { NATIONALITIES } from '../utils/nationalities';
import './NationalityDisplay.css';

const NationalityDisplay = ({ code, showName = true }) => {
  const normalizedCode = String(code || '').toUpperCase();
  const nationality = NATIONALITIES.find((option) => option.code === normalizedCode);

  if (!nationality) {
    return <span className="nationality-display nationality-display--empty">—</span>;
  }

  return (
    <span className="nationality-display" title={nationality.name}>
      <CountryFlag code={nationality.code} title={nationality.name} />
      {showName && <span className="nationality-display__name">{nationality.name}</span>}
    </span>
  );
};

export default NationalityDisplay;
